import FeatureGates from '@atlaskit/feature-gate-js-client';
import React from 'react';

import { FeatureGate, getFeatureGateOptions, isFeatureGateEnabled } from '@/utils/feature-gate';

import useOrgUserController from './org-user-controller';

type FeatureGatesContextType = {
  allowLowTraffic?: boolean;
};

export const FeatureGatesContext = React.createContext<FeatureGatesContextType>({});

const useFeatureGatesController = () => {
  const { orgId } = useOrgUserController();
  const [isInitialized, setIsInitialized] = React.useState(FeatureGates.initializeCompleted());

  React.useEffect(() => {
    if (isInitialized || !orgId) return;

    const initializeGates = async () => {
      if (!isInitialized) {
        try {
          await FeatureGates.initialize(getFeatureGateOptions(), {
            atlassianOrgId: orgId,
          });
          setIsInitialized(FeatureGates.initializeCompleted());
        } catch (e) {
          // @see https://atlassian-2y.sentry.io/issues/5476500964/?project=5988855
          // skip error handling for unauthorized requests
        }
      }
    };
    initializeGates();
  }, [isInitialized, orgId]);

  return React.useMemo(() => {
    if (!isInitialized) {
      return {};
    }

    return {
      allowLowTraffic: isFeatureGateEnabled(FeatureGate.ALLOW_LOW_TRAFFIC),
      allowSLODebug: isFeatureGateEnabled(FeatureGate.ALLOW_SLO_DEBUG),
    };
  }, [isInitialized]);
};

export default useFeatureGatesController;
